// MISC
import ScrollTo from '../classes/ScrollTo';

// Helpers
import getPosition from '../helpers/position';

class AnchorsModule {
    constructor() {
        // ES6 Rebind
        this.onClickAnchorLink = this.onClickAnchorLink.bind(this);

        // Config
        this.threshold = 40;

        this.initialize();
    }

    initialize() {
        this.setSizes();
        this.bindUI();
        this.bindEvents();

        this.findEligibleAnchors();
        this.buildAnchorsList();
    }

    bindUI() {
        this.ui = {};

        this.ui.$body = document.body;
        this.ui.$anchorsTargets = document.querySelectorAll(".js-anchors-target");
        this.ui.$anchors = document.querySelector('.js-anchors');
    }

    bindEvents() {
        window.addEventListener('scroll', this.onScroll.bind(this));
    }

    setSizes() {
        this.windowHeight = window.innerHeight;
    }

    onClickAnchorLink(e) {
        const currentTarget = e.currentTarget,
            targetHref = currentTarget.getAttribute('href'),
            $foundTarget = document.querySelector(targetHref);


        new ScrollTo(this.ui.$body, {
            dist: getPosition($foundTarget).top - this.threshold
        });
    }

    findEligibleAnchors() {
        this.anchors = [];

        let titleCounter = 0;

        [].forEach.call(this.ui.$anchorsTargets, (target, index) => {
            // Je cherche les H2.
            const foundTitles = target.querySelectorAll('h2');
            let tempEl = {};

            [].forEach.call(foundTitles, (title, titleIndex) => {
                titleCounter++;

                const computedID = `anchor${titleCounter}`;

                title.id = computedID;

                tempEl = {
                    el: title,
                    id: computedID,
                    text: title.innerHTML
                };

                this.anchors.push(tempEl);
            });
        });
    }

    buildAnchorsList() {
        // Loop around the anchors array.
        [].forEach.call(this.anchors, (el, index) =>{
            // Create a LI DOM Node
            let anchorItem = document.createElement("li");
            anchorItem.className = 'list__item';

            // Create a A DOM Node with the corresponding ID
            let anchorLink = document.createElement("a");
            anchorLink.innerHTML = el.text;

            anchorLink.className = "anchor js-goto";
            anchorLink.setAttribute('href', `#${el.id}`);
            anchorLink.setAttribute('data-href', `${el.id}`);

            anchorLink.addEventListener('click', this.onClickAnchorLink);

            anchorItem.appendChild(anchorLink);

            // Append the LI into this.ui.$anchors
            this.ui.$anchors.appendChild(anchorItem);

            // Once I've reached the last iteration of the anchors array, I trigger a custom 'goto:start' event to the body
            // In order to start the module the other way
            if (index == this.anchors.length - 1) {
                const event = new Event("goto:start");
                this.ui.$body.dispatchEvent(event);
            }
        });
    }

    activeAnchor() {
        [].forEach.call(this.anchors, (anchor, index) =>{
            const anchorItem = anchor.el;
            const anchorTop = anchorItem.getBoundingClientRect().top;

            if (anchorTop < this.windowHeight) {
                this.ui.$anchors.children[index].classList.add("is-active");
            } else {
                this.ui.$anchors.children[index].classList.remove("is-active");
            }
        });
    }

    onScroll() {
        this.activeAnchor();
    }
}

export default AnchorsModule;
